$('html').removeClass('no-js');

$(function () {
    /* global Modernizr:true */
    $('#lightgallery').lightGallery({
        selector: 'a'
    });

    // same height blog
    var highestBlock = 0;
    $('#alle_blogs .item .blog-info').each(function () {
        if ($(this).height() > highestBlock) {
            highestBlock = $(this).height();
        }
    });
    $('#alle_blogs .item .blog-info').height(highestBlock);


    var _this = this,
        _body = $('body');
    /**
     * Initialize
     */
    _this.init = function()
    {

        $('a[rel="external"]').attr('target', '_blank');
        _body.addClass('loaded').removeClass('nav-open');

        if (window.matchMedia("(max-width: 768px)").matches) {
            /* the viewport is less than 768 pixels wide */
            $('.screenshots').slick({
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 2000,
                dots: false,
                prevArrow: false,
                nextArrow: false
            });
        }




    };

    /**
     *  If body is not loaded, init
     */
    if (!_body.hasClass('loaded')) {
        _this.init();
    }

    $('.more a').click(function(){
        $('html, body').animate({
            scrollTop: $( $(this).attr('href') ).offset().top
        }, 500);
        return false;
    });

});

/*
$(document).ready(function() {
    if (window && window.innerWidth >= 992) {
        $('#home_page').fullpage({
            responsiveHeight: 600,
            afterResponsive: function (isResponsive) {
            }
        });
    }
});
 */

// Initialize and add the map
function initMap() {
    // The location of Uluru
    var uluru = {lat: 53.2025215, lng: 5.7849016};
    // The map, centered at Uluru
    var map = new google.maps.Map(
        document.getElementById('map'), {zoom: 17, center: uluru});
    // The marker, positioned at Uluru
    var marker = new google.maps.Marker({position: uluru, map: map});
}


function openNav() {
    document.getElementById("full_navigation").style.height = "100%";
}

function closeNav() {
    document.getElementById("full_navigation").style.height = "0%";

}